export default __webpack_public_path__ + "static/media/apple.e0ec3a41.svg";